<template>
    <div>
        <div class="box760">
            <div class="steps flex justify-content align-items">
                <div class="item active justify-content align-items flex column">
                    <p class="circular"><i></i></p>
                    <p class="text">填写资料</p>
                </div>
                <div class="line line-ff9203"></div>
                <div class="item underway justify-content align-items flex column">
                    <p class="circular"><i></i></p>
                    <p class="text">达人培训</p>
                </div>
                <div class="line"></div>
                <div class="item justify-content align-items flex column">
                    <p class="circular"><i></i></p>
                    <p class="text">认证成功</p>
                </div>
            </div>
        </div>
        <div class="box760 white-bg shadow fromBox border">
            <h3 class="attestation-title">请选择您希望的培训方式</h3>
            <div class="daren-select flex align-items justify-content">
                <div class="item border center">
                    <router-link to="/daren-register/online">
                        <h3 class="title">线上培训</h3>
                        <p class="desc">线上10分钟完成{{this.$store.state.siteName}}认证</p>
                    </router-link>
                </div>
<!--                <div class="item border center">-->
<!--                    <router-link to="/daren-register/offline">-->
<!--                        <h3 class="title">线下培训</h3>-->
<!--                        <p class="desc">到现场近距离认识{{this.$store.state.siteName}}</p>-->
<!--                    </router-link>-->
<!--                </div>-->
            </div>
            <div class="tips">
                <p>温馨提示：</p>
<!--                <p>1.线下培训需要本人带上个人身份证、手机到现场进行培训；</p>-->
                <p>线上培训需要进行个人流量资源等信息登记、完成{{this.$store.state.siteName}}使用教程的学习以及题目作答等。</p>
            </div>
        </div>
    </div>
</template>
<script>
import {myDarenInfo} from '@/config/api.js'
export default {
  name: 'DarenSelect',
    inject:['reload'],
    data () {
      return {
          is_auth: '',
          newbie_task: '',
          auth_type: '',
          isReload: true,
      }
    },
    methods: {
      getInfo () {
          let data = {
              user_id: this.$store.state.user_id,
              user_type: this.$store.state.user_type,
          };
          this.$post(myDarenInfo, data)
              .then(res => {
                  let data = res.data;
                  this.is_auth = Number(data.is_auth);
                  this.newbie_task = Number(data.newbie_task);
                  this.auth_type = Number(data.auth_type);
                  this.$store.commit('changeAuthType',this.auth_type);
                  this.$store.commit('changeIsAuth',this.is_auth);
                  this.$store.commit('changeNewbieTask',this.newbie_task);
              })
              .catch(err => {
                  window.console.log(err)
              })
      }
    },
    mounted() {
      this.getInfo();
    }
}
</script>
<style scoped>
    .daren-select{padding:50px 0 30px 0;}
    .daren-select .item{width:300px;height: 160px;margin:0 10px;cursor: pointer;}
    .daren-select .item:hover{color:#ff9203;border:1px #ff9203 solid;}
    .daren-select .item .title{font-size:18px;margin:50px 0 10px 0;}
    .tips{width: 624px;margin: 0 auto 40px auto;line-height: 30px;color:#666;}
</style>
